import formReducer from '../formsReducer'

const formName = 'orders/rejectOrder'

export default formReducer(formName)
